<template>
<div>
  <div class="res-container">
    <div
      v-for="(item, index) in items"
      :key="index"
      :class="item.class"
      v-on="
        item.isLast == true ? { mouseover: rightHover, mouseout: rightOut } : {}
      "
      class="res-column bg"
      :style="[
        {
          'background-image':
            item.gradiant +
            ', url(' +
            require('@/assets/imgs/' + item.imgNmae) +
            ')',
        },
      ]"
    >
      <v-row justify="center" align="center" style="height: 100%">
        <v-col cols="3" class="m">
          <div class="titl ml-16 mt-n16 ">{{ item.title }}</div>
          <hr class="text-left" />
        </v-col>
        <v-col cols="8" class=" ">
          <div class="text  ">{{ item.text }}</div>
        </v-col>
      </v-row>
    </div>
  </div>
  
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          class: "left",
          title: "Business Solutions and Strategies",
          text: "Every business has areas of inefficiency, and when it comes to law firms, our team of expert consultants can not only help to identify the inefficiencies but come up with intelligent innovative strategies and solutions tailored to your practice.",
          imgNmae: "shutterstock_1332814550.jpg",
          gradiant:
            "linear-gradient(to right,  rgba(168,30,45, .8) 10%  ,rgba(168,30,45, .9) 80%) ",
        },
        {
          class: "middle",
          title: "Network and Technology",
          text: "We have specialist on hand with decades of experience in the legal industry to help with your complete technology requirements. From software selection, to implementation, data migration, to customization, our team of experts is dedicated to unraveling and resolving the most complex technology challenges you may face.",
          imgNmae: "Network_and_Technology.jpg",
          gradiant:
            "linear-gradient(to right,  rgba(58,58,58, .5) 10%,rgba(58,58,58, .9) 88%)",
        },
        {
          isLast: true,
          class: "right",
          title: "Training and Support",
          text: "Technology investments are only as good as your ability to use them and leverage them to maximize productivity and increase the bottom line. Our trainers equip your team with the skills and knowledge they need, based on how your office works to improve proficiency and success of your practice. While our support team is there to prevent downtime and ensure efficiency and profitability.",
          imgNmae: "Training_Support.jpg",
          gradiant:
            "linear-gradient(to right,   rgba(31,98,142, .8) 10% ,rgba(31,98,142, .9) 88%)",
        },
      ],
    };
  },
  methods: {
    rightHover: function () {
      document.querySelector(".middle").classList.add("middle-hover");
      document.querySelector(".left").classList.add("left-hover");
    },
    rightOut: function () {
      document.querySelector(".middle").classList.remove("middle-hover");
      document.querySelector(".left").classList.remove("left-hover");

    },
  },
};
</script>


<style lang="scss" scoped>
// :root {
//   --leftofmiddle: calc(100% / 3);
// }
hr {
  border-top: 10px solid weight;
  width: 100px;
  margin-top: 20px;
  margin-left:18% !important;
}
.titl{
  color: white;
  font-size: 36px;
  margin-left:18% !important;
}
.text{

  color: white;
  font-size: 24px;
  margin-left:18% !important;
}
.bg {
  // background-attachment: fixed !important;
  background-size: cover !important;

  background-position: bottom bottom !important;
}
.res-container {
  margin-left: 5%;
  margin-right: 5%;
  z-index: 1;
  overflow: hidden;

  margin-top: 50px;
  height: 500px;

  position: relative;
}
.res-column {
  overflow: hidden;
  transition: 0.8s;
  position: absolute;
  top: 0px;
  height: 500px;
  width: 100%;
}
.left {
  background-color: black;
  left: 0px;
  z-index: 100;
  &:hover {
    ~ .middle {
      left: 100%;
      top:100% !important;
    }
    ~ .right {
      left: 100%;
      top:100% !important;
    }
  }
}
.middle {
  background-color: blue;
  // left: var(--leftofmiddle);
  left: calc(100% / 3);
  z-index: 200;
  &:hover {
    ~ .right {
      left: 100%;
    }
    left: 0%;
  }
}
.right {
  left: calc((100% / 3) * 2);
  background-color: green;
  z-index: 300;
  &:hover {
    left:0%;
  }
}
.left-hover{
  top:100% !important;
}
.middle-hover {
  left: 0%;
  top:100% !important;
}
@media only screen and (max-width: 1150px) {
}
@media only screen and (max-width: 600px) {
}
</style>
